import { Create, ListButton, TopToolbar } from 'react-admin';

import ChevronLeft from '@material-ui/icons/ChevronLeft';

import EvaluationUnitForm from './EvaluationUnitForm';

const EvaluationUnitActions = ({ basePath }: any) => (
  <TopToolbar>
    <ListButton
      basePath={basePath}
      label='ra.action.back'
      icon={<ChevronLeft />}
    />
  </TopToolbar>
);

const EvaluationUnitCreate = (props: any) => {
  return (
    <Create actions={<EvaluationUnitActions {...props} />} {...props}>
      <EvaluationUnitForm />
    </Create>
  );
};

export default EvaluationUnitCreate;
